import { render, staticRenderFns } from "./ValidateViewModal.vue?vue&type=template&id=6b1356a4&scoped=true"
import script from "./ValidateViewModal.vue?vue&type=script&lang=js"
export * from "./ValidateViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1356a4",
  null
  
)

export default component.exports